// extracted by mini-css-extract-plugin
module.exports = {"mobileAnnotation":"AnnotationForMobile_mobileAnnotation__155Xa","show":"AnnotationForMobile_show__Q_twR"};